export enum Theme {
  primary = 'primary',
  secondary = 'secondary',
  tertiary = 'tertiary',
  none = 'none',
  disabled = 'disabled'
}


export const ThemeValues = Object.values(Theme)
export type ThemeArray = typeof ThemeValues
export type TypeTheme = ThemeArray[number]
